module.exports = __webpack_public_path__ + "img/dbs.a5bdd427.png";